import { render } from "./DataOrderSearch.vue?vue&type=template&id=0f13e931"
import script from "./DataOrderSearch.vue?vue&type=script&lang=ts"
export * from "./DataOrderSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script